var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_14074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.33337C7.83152 3.33337 8.14946 3.46507 8.38388 3.69949C8.6183 3.93391 8.75 4.25185 8.75 4.58337C8.75 4.91489 8.6183 5.23284 8.38388 5.46726C8.14946 5.70168 7.83152 5.83337 7.5 5.83337",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 3.33337V7.91671C4.16669 8.02721 4.12279 8.1332 4.04465 8.21134C3.96651 8.28948 3.86053 8.33337 3.75002 8.33337H3.33335C3.22285 8.33337 3.11687 8.28948 3.03873 8.21134C2.96059 8.1332 2.91669 8.02721 2.91669 7.91671V5.83337",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.33335L6.885 1.76252C6.93977 1.7169 7.00641 1.68783 7.07711 1.67873C7.14781 1.66963 7.21964 1.68086 7.28419 1.71112C7.34873 1.74138 7.40331 1.78941 7.44153 1.84958C7.47976 1.90975 7.50004 1.97957 7.5 2.05085V7.11585C7.50004 7.18714 7.47976 7.25695 7.44153 7.31712C7.40331 7.37729 7.34873 7.42532 7.28419 7.45558C7.21964 7.48584 7.14781 7.49708 7.07711 7.48797C7.00641 7.47887 6.93977 7.44981 6.885 7.40419L5 5.83335H1.66667C1.55616 5.83335 1.45018 5.78945 1.37204 5.71131C1.2939 5.63317 1.25 5.52719 1.25 5.41669V3.75002C1.25 3.63951 1.2939 3.53353 1.37204 3.45539C1.45018 3.37725 1.55616 3.33335 1.66667 3.33335H5",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_14074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphone);
export default __webpack_public_path__ + "static/media/speakerphone.17a04087e7f63abe3eb019fd9050fd43.svg";
export { ForwardRef as ReactComponent };